webpackJsonp([11122216278935330000],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-es2015/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-stage-1/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-react/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-env/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/examples/async-validation.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDripForm = __webpack_require__("../src/index.js");
	
	var _reactDripFormComponents = __webpack_require__("./node_modules/react-drip-form-components/lib/index.js");
	
	var _components = __webpack_require__("./src/components/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-alert */
	/* eslint-disable import/extensions */
	/* eslint-disable import/no-unresolved */
	/* eslint-disable import/no-extraneous-dependencies */
	
	
	// Simulate API
	_reactDripForm.Validator.registerAsyncRule('checkValidAccount', function (value) {
	  return new Promise(function (resolve, reject) {
	    var whiteList = ['foo', 'bar', 'baz'];
	
	    setTimeout(function () {
	      if (whiteList.indexOf(value) > -1) {
	        resolve();
	      } else {
	        reject('Invalid account!');
	      }
	    }, 1000);
	  });
	});
	
	var AsyncValidationForm = (0, _reactDripForm.dripForm)({
	  validations: {
	    username: {
	      required: true,
	      between: {
	        min: 3,
	        max: 30
	      },
	      alphaNumeric: true,
	      lowercase: true,
	      checkValidAccount: true
	    },
	    displayName: {
	      required: true
	    }
	  }
	})(function (_ref) {
	  var handlers = _ref.handlers,
	      _ref$meta = _ref.meta,
	      invalid = _ref$meta.invalid,
	      pristine = _ref$meta.pristine,
	      validating = _ref$meta.validating;
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handlers.onSubmit },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'username' },
	        'Username'
	      ),
	      _react2.default.createElement(_reactDripFormComponents.Input, {
	        type: 'text',
	        id: 'username',
	        name: 'username',
	        label: 'Username'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'displayName' },
	        'Display Name'
	      ),
	      _react2.default.createElement(_reactDripFormComponents.Input, {
	        type: 'text',
	        id: 'displayName',
	        name: 'displayName',
	        label: 'Display Name'
	      })
	    ),
	    _react2.default.createElement(
	      _components.Button,
	      {
	        primary: true,
	        onClick: handlers.onSubmit,
	        disabled: invalid || pristine || validating
	      },
	      'Submit'
	    )
	  );
	});
	
	var BasicFormExample = function (_Component) {
	  _inherits(BasicFormExample, _Component);
	
	  function BasicFormExample() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BasicFormExample);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = BasicFormExample.__proto__ || Object.getPrototypeOf(BasicFormExample)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      values: {}
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BasicFormExample, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var location = this.props.location;
	      var values = this.state.values;
	
	
	      return _react2.default.createElement(
	        _components.Layout,
	        {
	          title: 'Async Validation',
	          location: location
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          'This is an example of asynchronous validations.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://github.com/tsuyoshiwada/drip-form-validator' },
	            'drip-form-validator'
	          ),
	          ' can register asynchronous validation with the ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'registerAsyncRule()'
	          ),
	          ' method.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Asynchronous validation is performed under the following conditions.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'If all synchronous verification corresponding to ',
	            _react2.default.createElement(
	              'code',
	              null,
	              'name'
	            ),
	            ' has passed'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'When the ',
	            _react2.default.createElement(
	              'code',
	              null,
	              'input.onBlur()'
	            ),
	            ' was executed'
	          )
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Example:'
	        ),
	        _react2.default.createElement(AsyncValidationForm, {
	          onChange: function onChange(v) {
	            return _this2.setState({ values: v });
	          },
	          onValidSubmit: function onValidSubmit(v) {
	            alert('See console');
	            console.log(v);
	          }
	        }),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Values:'
	        ),
	        _react2.default.createElement(
	          _components.Code,
	          { language: 'javascript' },
	          JSON.stringify(values, null, 2)
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Sample Code:'
	        ),
	        _react2.default.createElement(
	          _components.Code,
	          { language: 'javascript' },
	          'import React from \'react\';\nimport { dripForm, Validator } from \'react-drip-form\';\nimport { Input } from \'react-drip-form-components\';\n\n\n// Simulate API\nValidator.registerAsyncRule(\'checkValidAccount\', value => new Promise((resolve, reject) => {\n  const whiteList = [\'foo\', \'bar\', \'baz\'];\n\n  setTimeout(() => {\n    if (whiteList.indexOf(value) > -1) {\n      resolve();\n    } else {\n      reject(\'Invalid account!\');\n    }\n  }, 1000);\n}));\n\n\nconst AsyncValidationForm = dripForm({\n  validations: {\n    username: {\n      required: true,\n      between: {\n        min: 3,\n        max: 30,\n      },\n      alphaNumeric: true,\n      lowercase: true,\n      checkValidAccount: true,\n    },\n    displayName: {\n      required: true,\n    },\n  },\n})(({\n  handlers,\n  meta: { invalid, pristine, validating },\n}) => (\n  <form onSubmit={handlers.onSubmit}>\n    <div>\n      <label htmlFor="username">Username</label>\n      <Input\n        type="text"\n        id="username"\n        name="username"\n        label="Username"\n      />\n    </div>\n\n    <div>\n      <label htmlFor="displayName">Display Name</label>\n      <Input\n        type="text"\n        id="displayName"\n        name="displayName"\n        label="Display Name"\n      />\n    </div>\n\n    <Button\n      primary\n      onClick={handlers.onSubmit}\n      disabled={invalid || pristine || validating}\n    >\n      Submit\n    </Button>\n  </form>\n));'
	        )
	      );
	    }
	  }]);
	
	  return BasicFormExample;
	}(_react.Component);
	
	exports.default = BasicFormExample;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-examples-async-validation-js-35b3f4ba8ca5eb650fa2.js